<script lang="ts">
    import SearchBar from '$saga/views/Search/SearchBar.svelte';
    import {
        DefaultOptionList,
        DefaultOptions,
    } from '$saga/types/search.types';

    export let defaultOptions: string;
    export let defaultSportOptions: DefaultOptions = [];
    export let defaultDestinationOptions: DefaultOptions = [];
    export let title: string;
    let parsedDefaultOptions: DefaultOptionList;

    $: parsedDefaultOptions = JSON.parse(defaultOptions);
</script>

<div class="absolute bottom-[100%] w-full desktop:bottom-[200%]">
    <div class="p-l desktop:mx-auto desktop:max-w-layout-max desktop:px-5xl">
        <h1
            class="text-left text-[26px] font-semibold text-white desktop:w-1/2 desktop:text-4xl"
        >
            {title}
        </h1>
    </div>
</div>

<SearchBar
    defaultOptions={parsedDefaultOptions}
    {defaultDestinationOptions}
    {defaultSportOptions}
    isHomePage
/>
